
<template>
  <card>
    <h4 slot="header" class="card-title d-md-flex justify-content-between">
      <span>Yorumlar</span>
    </h4>
    <div class="d-flex align-items-center justify-content-between">
      <div class="filters my-3 d-flex justify-content-between">

        <b-button-group size="sm">
          <b-button class="btn-fill btn-success active type-button" id="type-all" v-on:click="changeType('all')">Tümü</b-button>
          <b-button class="btn-fill btn-success type-button" id="type-1" v-on:click="changeType(1)">Aktif</b-button>
          <b-button class="btn-fill btn-success type-button" id="type-1" v-on:click="changeType(0)">Pasif</b-button>
        </b-button-group>
      </div>

      <div class="filters my-3 d-flex ml-3 w-25 align-items-center position-relatice">
        <div class="input-group w-100 ml-3">
          <input type="text" class="form-control form-control-sm border-primary text-primary" v-on:keyup="getPosts()" v-model="query" placeholder="Arama">
          <div class="input-group-append">
            <span class="input-group-text bg-white border-primary text-primary" id="basic-addon2"><i class="fas fa-circle-notch fa-spin d-none" id="small-spinner"></i></span>
          </div>
        </div>
      </div>
    </div>
    <table class="table table-hover table-striped table-bordered mb-0">
      <caption v-if="!query">Toplam: {{total}}</caption>
      <thead class="thead-dark">
        <th style="width:60%">Yorum</th>
        <th>Kullanıcı</th>
        <th>Sayfa</th>
        <th>İşlem</th>
      </thead>
      <tbody>
        <tr v-for="item in table" :key="item.id">
          <td>{{item.comment}}</td>
          <td>{{item.user.username}}</td>
          <td>{{item.post.name}}</td>
          <td style="width:15%">
            <a href="javascript:void(0)" class="btn btn-xs btn-danger btn-fill" v-if="item.published" v-on:click="deactivate(item.id)" v-b-tooltip title="Pasif Et" id="deactivate-item.id"><i class="fas fa-times fa-fw"></i></a>
            <a href="javascript:void(0)" class="btn btn-xs btn-success btn-fill" v-if="!item.published" v-b-tooltip v-on:click="activate(item.id)" title="Aktif Et" id="activate-item.id"><i class="fas fa-check fa-fw"></i></a>
          </td>
        </tr>
      </tbody>
    </table>
    <nav v-if="!query" aria-label="Page navigation small">

      <ul class="pagination justify-content-end">
        <li class="page-item" v-bind:class="{disabled: isFirst()}"><a class="page-link" v-on:click="getPosts(page - 1,type)" >Öncesi</a></li>
        <li class="page-item" v-for="current in pageCount" v-if="isInScope(current)" v-bind:class="{active: isActive(current), 'mr-2': current == 1, 'ml-2': current == pageCount.length}" :key="current"><a href="javascript:void(0)" class="page-link active" v-on:click="getPosts(current,type)">{{current}}</a></li>
        <li class="page-item" v-bind:class="{disabled: isLast()}"><a class="page-link" v-on:click="getPosts(page + 1,type)">Sonrası</a></li>
      </ul>
    </nav>


  </card>
</template>
<script>
  import Card from 'src/components/UIComponents/Cards/Card.vue'

  export default {
    data: function () {
      return {
        comment:{
          is_active:0
        },
        table: null,
        total: 0,
        limit: localStorage.getItem('filterLimit'),
        page: 1,
        pageCount: null,
        query:null,
        navigation: true,
        type: 'all',
        viewCounts: []
      }
    },
    components: {
      Card
    },

    methods: {
      changeType: function(t){
        this.type = t
        var buttons = Array.prototype.slice.call(document.getElementsByClassName('type-button'))
        buttons.forEach(function(b){
          b.classList.remove('active')
        })
        event.target.classList.add('active')
        this.getPosts(1,this.type)
      },
      deactivate: function(id){
        this.toggleLoader()
        this.comment.published = 0
        this.$http.post('/api/comments/edit/' + id, this.comment).then(
          response => {
            this.notifier('top', 'right', 'warning', 'Yorum Yayından Kaldırıldı')
            this.getPosts(this.page,this.type)
            this.toggleLoader()
          },
          e => {
            this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
            this.toggleLoader()
          })
      },
      activate: function(id){
        this.toggleLoader()
        this.comment.published = 1
        this.$http.post('/api/comments/edit/' + id, this.comment).then(
          response => {
            this.notifier('top', 'right', 'success', 'Yorum Yayınlandı')
            this.getPosts(this.page,this.type)
            this.toggleLoader()
          },
          e => {
            this.notifier('top', 'right', 'danger', 'Bir Hata Oluştu')
            this.toggleLoader()
          })
      },
      isInScope: function(c){
        if(c === 1){
          return true
        }
        if(c === this.pageCount.length){
          return true
        }
        if(c - this.page > 3 || this.page - c > 3){
          return false;
        }
        return true
      },
      isActive: function (v) {
        return v === this.page
      },
      isFirst: function () {
        return this.page === 1
      },
      isLast: function () {
        return this.page === Math.ceil(this.total / this.limit)
      },
      getPosts: function (p = 1, t = 'all') {
        if(this.query){
          if(this.tmId){
            clearTimeout(this.tmId);
          }
          this.tmId = setTimeout(()=>{
            if(this.query){
              document.getElementById('small-spinner').classList.remove('d-none');
              this.$http.get('/api/search-comment/' + this.query)
              .then(
                response => {
                  document.getElementById('small-spinner').classList.add('d-none');
                  this.table = response.body
                  this.table.forEach(i=>{
                    i.comment = this.$sanitize(i.comment,{allowedTags: ['user-reference']}).replace(/<user-reference>/g,'@').replace(/<\/user-reference>/g, ' ');
                  })
                  clearTimeout(this.tmId);
                },
                er => {
                  this.notifier(
                    'top',
                    'right',
                    'danger',
                    'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.'
                    )
                  clearTimeout(this.tmId);
                })
            }
          },700)
        }else{
          this.type = t
          var url = '/api/filter/comments/limit/' + this.limit + '/page/' + p
          if(this.type !== 'all'){
             url = url + '/published/' + this.type
          }

          this.$http.get(url).then(
            response => {
              this.table = response.body.data
              this.table.forEach(i=>{
                i.comment = this.$sanitize(i.comment,{allowedTags: ['user-reference']}).replace(/<user-reference>/g,'@').replace(/<\/user-reference>/g, ' ');
              })
              this.total = response.body.meta.total
              this.page = p
              this.pageCount = []
              for (var i = 0; i < this.total / this.limit; i++) {
                this.pageCount.push(i + 1)
              }
            },
            er => {
              this.notifier(
                'top',
                'right',
                'danger',
                'Yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin. Problem devam ederse destek ekibine başvurunuz.'
                )
            })
        }
      },
      toggleNavigation () {
        var button = event.target
        if (this.navigation) {
          button.innerHTML = '<i class="fas fa-caret-down"></i>'
          this.navigation = false
        } else {
          button.innerHTML = '<i class="fas fa-caret-up"></i>'
          this.navigation = true
        }
      },
      toggleNewPostPanel (event) {
        event.stopPropagation()
        if (document.getElementById('new-post').classList.contains('d-none')) {
          document.getElementById('new-post').classList.remove('d-none')
        } else {
          document.getElementById('new-post').classList.add('d-none')
        }
      }
    },
    mounted: function () {
      this.$nextTick(function () {
        this.getPosts()
      })
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/CommentModules/Index.vue